module.exports = __webpack_public_path__ + "img/442.785f67ec.jpg";